/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { RouteComponentProps, useHistory } from "react-router-dom";
import UIConstants from "../../../../UIConstants";
import { useAppContext } from "./../../../Components/AppContext";
import IAppContext from "./../../../Components/AppContext/IAppContext";
import { fixedT, translationKeys } from "./../../../Internationalisierung/i18nBasis";
import { AppSnackbarAktion } from "./../AppSnackbarAktion";
import AppSnackbarTemplateProps from "./AppSnackbarTemplateProps";

export default class AppSnackbarTemplateModel {
    private readonly _history: RouteComponentProps["history"];
    private readonly _appContext: IAppContext;

    public constructor(private readonly _props: AppSnackbarTemplateProps) {
        this._history = useHistory();
        this._appContext = useAppContext();
    }

    public get zeigeAktion(): boolean {
        return !!this._props.action;
    }

    public get zeigeTyp(): boolean {
        return !!this._props.typBezeichnung && !!this._props.typMatchcode && !!this._props.typUrl;
    }

    public get typBezeichnung(): string {
        return this._props.typBezeichnung ?? "";
    }

    public get typMatchcode(): string {
        return this._props.typMatchcode ?? "";
    }

    public get typUrl(): string {
        return this._props.typUrl ?? "";
    }

    public get text(): string {
        return this._props.text;
    }

    public get aktionText(): string {
        switch (this._props.action) {
            case AppSnackbarAktion.NeuAnmelden:
                return fixedT(translationKeys.appSnackbarTemplate.neuAnmelden);
            case AppSnackbarAktion.NeuLaden:
                return fixedT(translationKeys.appSnackbarTemplate.neuLaden);
            case AppSnackbarAktion.ZurHauptseite:
                return fixedT(translationKeys.appSnackbarTemplate.zurHauptseite);
        }

        return "";
    }

    public readonly aktionKlick = () => {
        this._appContext.changeTracker.clearAll();
        switch (this._props.action) {
            case AppSnackbarAktion.NeuAnmelden:
                window.location.href = UIConstants.logoutPath;
                return;
            case AppSnackbarAktion.NeuLaden:
                window.location.reload();
                return;
            case AppSnackbarAktion.ZurHauptseite:
                this._history.location.pathname === "/"
                    ? window.location.reload()
                    : this._history.push("/");
        }
    };
}
